export default __webpack_public_path__ + "static/media/drivers-lorawan.c4536094.yaml";